import { render, staticRenderFns } from "./RolesSelector.vue?vue&type=template&id=8a71886e"
import script from "./RolesSelector.vue?vue&type=script&lang=js"
export * from "./RolesSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports